import moment from "moment";
import { Frequency } from "../pages/Transactions/panels/transactions/types";

/** Per-frequency max lookback for a recurring transaction's start date; mirrors api/src/Api/Domain/RecurringTransactions/entities.ts. */
export const RECURRING_TRANSACTION_PAST_LIMITS = {
  [Frequency.DAILY]: 7,
  [Frequency.WEEKLY]: 8,
  [Frequency.MONTHLY]: 6,
  [Frequency.ANNUALLY]: 2,
} as const;

export const getPastLimitLabel = (frequency: Frequency): string => {
  const limit = RECURRING_TRANSACTION_PAST_LIMITS[frequency];

  switch (frequency) {
    case Frequency.DAILY:
      return `${limit} days`;
    case Frequency.WEEKLY:
      return `${limit} weeks`;
    case Frequency.MONTHLY:
      return `${limit} months`;
    case Frequency.ANNUALLY:
      return `${limit} years`;
  }
};

export const calculateMaxAllowedPastDate = (
  frequency: Frequency,
  today: Date = new Date(),
): Date => {
  const todayMoment = moment(today);
  const limit = RECURRING_TRANSACTION_PAST_LIMITS[frequency];

  switch (frequency) {
    case Frequency.DAILY:
      return todayMoment.subtract(limit, "days").toDate();
    case Frequency.WEEKLY:
      return todayMoment.subtract(limit, "weeks").toDate();
    case Frequency.MONTHLY:
      return todayMoment.subtract(limit, "months").toDate();
    case Frequency.ANNUALLY:
      return todayMoment.subtract(limit, "years").toDate();
  }
};
